import React from "react";
import { AlertOctagon, AlertTriangle, Info, CheckCircle2 } from "lucide-react";

const map = {
  blocking: { cls: "sev-blocking", Icon: AlertOctagon, label: "Blocking" },
  critical: { cls: "sev-critical", Icon: AlertOctagon, label: "Critical" },
  warning:  { cls: "sev-warning",  Icon: AlertTriangle, label: "Warning" },
  info:     { cls: "sev-info",     Icon: Info,          label: "Info" },
  ok:       { cls: "sev-ok",       Icon: CheckCircle2,  label: "OK" },
};

export default function SeverityBadge({ severity = "info", children, compact = false, testId }) {
  const m = map[severity] || map.info;
  const Icon = m.Icon;
  return (
    <span
      data-testid={testId || `severity-${severity}`}
      className={`inline-flex items-center gap-1.5 ${m.cls} px-2 py-0.5 font-mono text-[11px] uppercase tracking-wider`}
    >
      <Icon size={12} strokeWidth={2} />
      {!compact && (children || m.label)}
    </span>
  );
}
